function P(props) {
  const { children, className, small } = props;
  return (
    <p className={`${className} ${small ? "text" : "text-xl"}`}>{children}</p>
  );
}

export default P;
